import { useEffect, useState } from "react";
import { Button, Spin } from "antd";
import OtpInput from "react-otp-input";
import toast from "react-hot-toast";
import Lottie from "lottie-react";

import lockAnim from "../../assets/animations/lock.json";
import { verifyQRCodeAuth } from "../../modules/auth/services/otpApi";
import AuthenticatorReset from "./AuthenticatorReset";

const AuthenticatorContent = ({ username, onCancel, onSuccess }) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [countdown, setCountdown] = useState(30);

  const [showReset, setShowReset] = useState(false);

  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));

  const isEnabled = currentUser?.user?.twoFaEnabled === true;

  useEffect(() => {
    const interval = setInterval(() => {
      setCountdown((prev) => (prev > 0 ? prev - 1 : 30));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const handleVerify = async () => {
    if (otp.length !== 6) {
      toast.error("Code invalide");
      return;
    }

    setLoading(true);
    try {
      const response = await verifyQRCodeAuth({
        username,
        code: otp,
      });

      if (response?.statusCode === 200) {
        toast.success("Code validé");

        onSuccess?.();
      } else {
        toast.error("Code incorrect");
      }
    } catch (e) {
      toast.error("Erreur serveur");
    } finally {
      setLoading(false);
    }
  };

  if (showReset) {
    return (
      <AuthenticatorReset
        username={username}
        onClose={() => setShowReset(false)}
      />
    );
  }

  return (
    <div className="otp-wrapper">

      <div className="text-center">

        <div style={{ width: 80, margin: "0 auto", marginBottom: 30 }}>
          <Lottie animationData={lockAnim} loop autoplay />
        </div>

        <div className="text-center mb-3">
          <h5 className="mb-4">Vérification de sécurité</h5>

          <p style={{ color: "#6c757d", fontSize: 13, marginTop: 8 }}>
            Entrez le code généré par google authentificator.
          </p>
        </div>
        
        <div className="otp-timer mb-4">
          ⏳ Le code expire chaque 30s : {countdown}s
        </div>

        <div className="otp-container-verify mb-3">
          <OtpInput
            value={otp}
            onChange={setOtp}
            numInputs={6}
            renderInput={(props) => (
              <input {...props} className="otp-input text-center" />
            )}
          />
        </div>

        {/* <div className="text-danger small mt-2">
          <Button type="link" onClick={() => setShowReset(true)}>
            Je scanne à nouveau le QR
          </Button>
        </div> */}

        <div className="d-flex justify-content-center gap-2 mt-4">
          <Button onClick={onCancel} disabled={loading}>
            Annuler
          </Button>

          <Button type="primary" onClick={handleVerify} disabled={loading}>
            {loading ? <Spin size="small" /> : "Valider"}
          </Button>
        </div>

      </div>
    </div>
  );
};

export default AuthenticatorContent;